<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">
        {{ $t('maintenance.menu.desc.schedule') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            variant="secondary"
            @click="$router.push({ name: 'Service' })"
            :text="$t('global.back')"
            icon="icon-outline_arrow-left"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <!-- Table -->
        <div class="table-responsive my-3">
          <McGrapqlTable
            :apiClient="query"
            :fields="localizeFields"
            :customHandlers="customHandlers"
            :hasCheckbox="false"
            :searchable="true"
            :withCard="true"
            customButton
          >
            <template #button-header>
              <McButton
                variant="secondary"
                :text="$t('global.action.upload')"
                icon="icon-outline_upload"
                class="me-2 mb-2"
                @click="$router.push({ name: 'Service Schedule Import' })"
              />
            </template>
            <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
              <McFilterSelect
                :defaultColumnOrder="initialFields"
                :currentColumnOrder="dataFields"
                @setColumn="handleSetDataFields"
                @setField="handleFieldShow"
              />
            </template>
            <template #cell(vehicle.vehicleType.manufacturer)="data">
              {{
                data.item.vehicle.vehicleType.manufacturer +
                ' - ' +
                data.item.vehicle.vehicleType.model
              }}
            </template>
          </McGrapqlTable>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
import McFilterSelect from '@/components/McFilterSelect'
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'
import { GET_SERVICE_SCHEDULES_BY_VEHICLE } from '@/services/api/maintenance/serviceSchedules'
import { MixPanel } from '@/mixin/mixpanel'
import cloneDeep from 'lodash/cloneDeep'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Penjadwalan Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    McFilterSelect,
    McButton,
  },
  mixins: [MixPanel],
  data() {
    return {
      show_model: [],

      customHandlers: {
        handleAdd: () => {
          return this.$router.push({ name: 'Create Service Schedule' })
        },
        handleClickRow: (item) => {
          return this.$router.push({
            name: 'Detail Service Schedule',
            params: { vehicleId: item.vehicleId },
          })
        },
      },
      created: true,
      fieldShow: JSON.parse(localStorage.getItem('ssFields')),
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    title() {
      return this.$t('maintenance.frontPage.title.serviceSchedule')
    },
    optionalFields() {
      let fields = []

      if (
        this.hasAccess([
          'maintenance-group:read',
          'maintenance-group:update',
          'maintenance-group:create',
          'maintenance-group:delete',
        ])
      ) {
        fields = [
          {
            key: 'totalServiceSchedulesGroups',
            label: 'maintenance.field.totalGroupService',
            isSortable: true,
            thStyle: 'width: 350px',
          },
        ]
      }
      return fields
    },

    storedFields() {
      return this.fieldShow.column
    },

    fields() {
      if (this.fieldShow) {
        return this.storedFields
      } else {
        return [
          {
            key: 'vehicle.licensePlate',
            label: 'global.object.licensePlate',
            isSortable: true,
            isRedirectable: true,
            thStyle: 'width: 350px',
            isLocked: true,
            shown: true,
          },
          {
            key: 'vehicle.vehicleType.type',
            label: 'global.field.vehicleType',
            isSortable: true,
            thStyle: 'width: 350px',
            shown: true,
          },
          {
            key: 'vehicle.vehicleType.manufacturer',
            label: 'setting.list.fleetSetting.fleetModel',
            isSortable: true,
            thStyle: 'width: 350px',
            shown: true,
          },
          {
            key: 'totalServiceSchedules',
            label: 'maintenance.field.totalScheduleService',
            isSortable: true,
            thStyle: 'width: 350px',
            shown: true,
          },
          ...this.optionalFields,
        ]
      }
    },

    localizeFields() {
      const field = cloneDeep(this.fields)
      field.forEach((item) => (item.label = `${this.$t(item.label)}`))
      return field
    },

    query() {
      return {
        get: async (filter) => {
          if (this.created) filter.orderBy = [JSON.stringify({ 'vehicle.licensePlate': 'asc' })]

          const self = this
          self.created = false

          const res = await this.$apollo.query({
            client: 'clientLowPrio',
            fetchPolicy: 'no-cache',
            query: GET_SERVICE_SCHEDULES_BY_VEHICLE,
            variables: {
              filter: {
                ...filter,
                vehicleStatus: ['I', 'R'],
              },
            },
          })

          return res.data.serviceSchedulesByVehicle.serviceSchedulesByVehicle
        },
      }
    },
  },

  created() {
    this.setDefaultFields()
  },

  mounted() {
    this.track('View Service Scheduler Page')
  },

  methods: {
    setDefaultFields() {
      const defaultFields = this.fields.map((field) => {
        if (!field.hasOwnProperty('shown')) field.shown = true
        return field
      })
      if (!localStorage.getItem('ssFields')) {
        localStorage.setItem('ssFields', JSON.stringify({ column: defaultFields }))
      }
    },
    handleFieldShow(fields) {
      localStorage.setItem('ssFields', JSON.stringify({ column: fields }))
    },
  },
}
</script>
